import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  getCurrentEscolaId,
  getUserToken,
  isCurrentUserAdmin,
  setUserToken,
  subscribeToUserToken,
} from "./api/base";
import { Layout } from "./components/Layout";
import { AtividadesForm } from "./components/atividades/AtividadesForm";
import { AtividadesLista } from "./components/atividades/AtividadesLista";
import { EscolaSelecaoPage } from "./components/escolas/EscolaSelecaoPage";
import { EscolasForm } from "./components/escolas/EscolasForm";
import { EscolaLista } from "./components/escolas/EscolasLista";
import { LoginPage } from "./components/login/LoginPage";
import { PeriodosLetivosForm } from "./components/periodosLetivos/PeriodosLetivosForm";
import { PeriodosLetivosLista } from "./components/periodosLetivos/PeriodosLetivosLista";
import { RelatoriosNotasDaTurmaPage } from "./components/relatorios/notasDaTurma/NotasDaTurmaPage";
import { RelatoriosPlanilhaDeNotasPage } from "./components/relatorios/planilhaDeNotas/PlanilhaDeNotasPage";
import { TurmasPage } from "./components/turmas/TurmasPage";
import { UsuariosConta } from "./components/usuarios/UsuariosConta";
import { UsuariosForm } from "./components/usuarios/UsuariosForm";
import { UsuariosLista } from "./components/usuarios/UsuariosLista";
import "./custom.css";

interface AppState {
  userToken: string | null;
}

export default class App extends Component<Record<string, unknown>, AppState> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = {
      userToken: getUserToken(),
    };
    subscribeToUserToken((value) => {
      this.setState({ userToken: value });
    });
  }

  render(): React.ReactNode {
    const isAuthenticated = !!this.state.userToken;
    const schoolSelectionRequired =
      isAuthenticated && isCurrentUserAdmin() && !getCurrentEscolaId();

    return (
      <Layout authenticated={isAuthenticated}>
        <Routes>
          {!isAuthenticated ? (
            <>
              <Route
                path="/login"
                element={<LoginPage onTokenChanged={(v) => setUserToken(v)} />}
              />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : schoolSelectionRequired ? (
            <>
              <Route
                path="/escolas/selecionar"
                element={<EscolaSelecaoPage />}
              />
              <Route
                path="*"
                element={<Navigate to="/escolas/selecionar" replace={true} />}
              />
            </>
          ) : (
            <>
              <Route path="/" element={<Navigate to="/atividades" />} />
              <Route
                path="/escolas/selecionar"
                element={<Navigate to="/" replace={true} />}
              />
              <Route path="/atividades" element={<AtividadesLista />} />
              <Route path="/atividades/form" element={<AtividadesForm />} />
              <Route path="/atividades/form/:id" element={<AtividadesForm />} />
              <Route path="/turmas" element={<TurmasPage />} />
              <Route
                path="/relatorios"
                element={
                  <Navigate to="/relatorios/notasDaTurma" replace={true} />
                }
              />
              <Route
                path="/relatorios/notasDaTurma"
                element={<RelatoriosNotasDaTurmaPage />}
              />
              <Route
                path="/relatorios/planilhaDeNotas"
                element={<RelatoriosPlanilhaDeNotasPage />}
              />
              <Route path="/escolas" element={<EscolaLista />} />
              <Route path="/escolas/form/" element={<EscolasForm />} />
              <Route path="/escolas/form/:id" element={<EscolasForm />} />
              <Route
                path="/periodos-letivos"
                element={<PeriodosLetivosLista />}
              />
              <Route
                path="/periodos-letivos/form"
                element={<PeriodosLetivosForm />}
              />
              <Route
                path="/periodos-letivos/form/:id"
                element={<PeriodosLetivosForm />}
              />
              <Route path="/usuarios" element={<UsuariosLista />} />
              <Route path="/usuarios/form" element={<UsuariosForm />} />
              <Route
                path="/usuarios/form/:usuario"
                element={<UsuariosForm />}
              />
              <Route path="/usuarios/conta" element={<UsuariosConta />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </Layout>
    );
  }
}
